'use strict';

const StripeRepo = ['$resource', function($resource) {
  return $resource('/api/stripe/:controller',
    {}, {
      // connect stripe group to accept payments as toGroup
      getClientId: {
        method: 'GET',
        params: {controller: 'clientid'}
      },
      connectStripeGroup: {
        method: 'POST',
        params: {controller: 'connectgroup'}
      },
      // other stripe
      getKey: {
        method: 'GET',
        params: {controller: 'key'}
      },
      newSource: {
        method: 'POST',
        params: {controller: 'sources'}
      },
      getPaymentMethods: {
        method: 'GET',
        params: {controller: 'paymentmethods'},
        isArray: true
      },
      // cards
      getCards: {
        method: 'GET',
        params: {controller: 'cards'}
      },
      updateCard: {
        method: 'PUT',
        params: {controller: 'cards'}
      },
      deleteCard: {
        method: 'DELETE',
        params: {controller: 'cards'}
      },
      // accounts
      getAccounts: {
        method: 'GET',
        params: {controller: 'accounts'}
      },
      verifyAccount: {
        method: 'PUT',
        params: {controller: 'accountverify'}
      },
      getAccountVerifyMode: {
        method: 'GET',
        params: {controller: 'accountverifymode'}
      },
      deleteAccount: {
        method: 'DELETE',
        params: {controller: 'accounts'}
      },
      deleteBankAccount: {
        method: 'DELETE',
        params: {controller: 'bankaccounts'},
        isArray: true
      },
      attachPaymentMethodToUser: {
        method: 'POST',
        params: {controller: 'paymentmethods'}
      },
      createPaymentIntent: {
        method: 'POST',
        params: {controller: 'paymentintent'}
      },
      createBankAccountSetupIntent: {
        method: 'POST',
        params: {controller: 'setupintent'}
      }
    });
}];

export default StripeRepo;
